'use strict';

function ConstructionSiteSupervisorsController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService) {
	var self = this;

    this.getConstructionSiteSupervisors = function() {
        var contractId = dataHolderFactory.getSavedContractDetails().id;
        var workSiteId = dataHolderFactory.getCurrentSiteId();
        usSpinnerService.spin('spinner-1');
        dataRequestService.getConstructionSiteSupervisors(contractId,workSiteId).then(function(result) {
          usSpinnerService.stop('spinner-1');
          $scope.constructionSiteSupervisorsViewControl.supervisors = result;
        }, function(error) {
          usSpinnerService.stop('spinner-1');
          console.log(error);
        });
      };

    $scope.initConstructionSiteSupervisorsController = function() {
        $scope.constructionSiteSupervisorsViewControl = objectMakerFactory.viewObjectControlForConstructionSiteSupervisors();
        self.getConstructionSiteSupervisors();
    };

    $scope.restoreViewControl = function() {
        $rootScope.appControl.showConstructionSiteSupervisorsBox = false;
    };
}
ConstructionSiteSupervisorsController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService']
export default ConstructionSiteSupervisorsController


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/constructionSiteSupervisorsController.js